import React from 'react'

import Link from './Link'
import { IconList } from './Icons'
import Stats from './Stats'
import Distance from './Distance'
import PlaceHolder from './PlaceHolder'

import { reverse, absoluteUrl } from '../urls'

import DeviationIcon from '../icons/deviation.svg'

import { STAGE, DEVIATION_OF_TRAIL } from '../trans'

const InfoPanelSummary = (props) => {
  const { icons, distance_from_trail, length, time, elevation, children, trail_id, route_id } = props
  return (
     <>
       
      { icons && (
        <div className="pwa__infopanel__amenities pwa__amenities__list ">
          <IconList icons={icons} />
        </div>
      )}

      { route_id && (
          <div className="pwa__infopanel__trail">
           <PlaceHolder value={trail_id}>
              <Link to={{ pathname: reverse(route_id, trail_id), hash: '' }}>
                {STAGE} {trail_id}
              </Link>
            </PlaceHolder>
          </div>
      )}

      { children }

      { distance_from_trail > 100 && (
        <i className="pwa__list__deviation fade-in delay">
          <DeviationIcon/>
          <Distance value={distance_from_trail} className="pwa__list__distance"/>
          {DEVIATION_OF_TRAIL}
        </i>
      )}

      <Stats length={length} time={time} elevation={elevation} />
     </>
  )
}

export default InfoPanelSummary
